function Permission({ item }) {
    return (
        <tr className="hover:bg-gray-50/40 dark:hover:bg-gray-700/30 transition-colors">
            <td className="px-5 py-3.5 text-sm font-medium text-gray-800 dark:text-gray-100">
                {item?.name}
            </td>
            <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">
                {item?.description || <span className="text-gray-300 dark:text-gray-600">—</span>}
            </td>
            <td className="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400 font-mono">
                {item?.slug}
            </td>
        </tr>
    );
}

export default Permission;
